import { AppContext } from '../../services/AppContext';
import { React, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const ManagerDashboard = () => {
    const { t } = useTranslation();
    const { apiClient, user } = useContext(AppContext);
    const [dashboardData, setDashboardData] = useState();

    const fetchData = async () => {
        if (user.role !== 'Manager') {
            return;
        }

        const data = await apiClient.getManagerStats();

        if (!data.hasErrors) {
            setDashboardData(data);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className="dashboard">
            {dashboardData && (
                <div>
                    <h1 className="dashboard-title">{t('pages.home.managerDashboard.title')}</h1>
                    <div className="tiles">
                        <div className="tile">
                            <h2 className="tile-title">{t('pages.home.managerDashboard.attendance')}</h2>
                            <p>{dashboardData.attendenceForMonth}</p>
                        </div>
                        <div className="tile">
                            <h2 className="tile-title">{t('pages.home.managerDashboard.earned')}</h2>
                            <p>
                                {dashboardData.totalEarned.amount}{' '}
                                {dashboardData.totalEarned.currency.symbol}
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ManagerDashboard;